module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/antoinette-mccurdy-59a689ed5420da7af92b634eaad22425.jpg";